import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "react-jss";
import { useDispatch } from "react-redux";
import { ColorType } from "../../../../common/enum/ColorType";
import { ContentType } from "../../../../common/enum/files/ContentType";
import { FileSize } from "../../../../common/enum/files/FileSize";
import { fetchImportCustomerFile, fetchImportTemplate } from "../../../../redux/actions/user/users/users";
import { useAppSelector } from "../../../../redux/hooks";
import { Alert } from "../../../common/alert/alert";
import { ButtonPrimary } from "../../../common/buttons/buttons";
import { DownloadDataIcon } from "../../../common/downloadData/downloadData";
import { NavHeaderComponent } from "../../../common/navHeader/navHeader";
import { PopUpForm } from "../../../common/popup/popUpForm/popUpForm";
import { UploadFileDropzone } from "../../../common/uploadFileDropzone/uploadFileDropzone";
import { CustomersImportList } from "../list/list";

export const CustomersImportContent = () => {
    const theme = useTheme() as any;
    const dispatch = useDispatch();
    const { loading, templateCustomerImport, importResponse } = useAppSelector((state) => state.customerImport);
    const { t } = useTranslation("common", { keyPrefix: "USER_IMPORT" });
    const [modalUpload, setModalUpload] = useState<boolean>(false);
    const [document, setDocument] = useState<File>();

    useEffect(() => {
        !templateCustomerImport && dispatch(fetchImportTemplate());
    }, []);

    const downloadAction = () => {
        window.open(templateCustomerImport, "_blank");
    };
    const uploadDocument = () => {
        dispatch(fetchImportCustomerFile(document)).then(() => {
            setModalUpload(false);
            setDocument(undefined);
        });
    };

    return (
        <>
            <NavHeaderComponent
                title={t("TITLE_CUSTOMER")}
                action={
                    <ButtonPrimary
                        title={t("BUTTON")}
                        handleClick={() => setModalUpload(true)}
                    />
                }
                endAction={
                    <DownloadDataIcon
                        title={t("DOWNLOAD")}
                        onDownloadAction={downloadAction}
                    />
                }
            />
            {importResponse && importResponse?.resultsError === 0 && (
                <Alert
                    colorType={ColorType.success}
                    fontSize={theme.fonts.sizes.xl}
                    data={t("MESSAGE_CUSTOMER")}
                />
            )}

            {importResponse && importResponse?.resultsError > 0 && <CustomersImportList />}
            <PopUpForm
                content={
                    <UploadFileDropzone
                        allowedExtensions={[ContentType.EXCEL]}
                        onFilesChange={setDocument}
                        disabled={false}
                        maxSize={FileSize._5MB}
                    />
                }
                title={t("MODAL_TITLE")}
                height={"30vh"}
                width={"40vw"}
                isVisible={modalUpload}
                isDisabledButton={!document}
                onSave={uploadDocument}
                buttonSaveTitle={t("ACCEPT")}
                onCancel={() => {
                    setModalUpload(false);
                    setDocument(undefined);
                }}
                isLoading={loading}
            />
        </>
    );
};
